import { IoClose } from "react-icons/io5";
import { IoMdCheckmark } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Modal from "../../Submissions/components/Modal";
import { useState } from "react";
import { ActionButton } from "../../../components/Forms/ActionButton";
import { useDeleteBlog, useUpdateBlogStatus } from "../../../queries/blog";
import Chip from "../../../components/Chip";
import { FaTrash } from "react-icons/fa";
const ViewIcon = require("../../../utils/media/icons/view_icon.png");

const UserBlogListTable = ({ data, toast }) => {

    const navigate = useNavigate();
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [isRejectionModelOpen, setIsRejectionModelOpen] = useState(false);
    const [deleteModel, setDeleteModel] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    const [rejectionReason, setRejectionReason] = useState("");

    const { mutateAsync } = useUpdateBlogStatus();
    const { mutateAsync: deleteBlog } = useDeleteBlog();

    const handleReject = async (id) => {
        mutateAsync({
            status: 'reject',
            blogId: id,
            rejectReason: rejectionReason,
        }, {
            onSuccess: () => {
                toast.success("Blog Rejected");
            },
            onError: () => {
                toast.error("Error rejecting blog");
            }
        });
        setIsModelOpen(false);
    }

    const handleApprove = async (id) => {
        mutateAsync({
            status: 'approve',
            blogId: id,
            rejectReason: '',
        }, {
            onSuccess: () => {
                toast.success("Blog Approved");
            },
            onError: () => {
                toast.error("Error approving blog");
            }
        });
        setIsModelOpen(false);
    }

    const handleDelete = async (id) => {
        deleteBlog(id, {
            onSuccess: () => {
                toast.success("Blog Deleted");
            }
        });
    }
    
    const renderChips = (status) => {
        if (status === 'active') {
            return <Chip value={'Active'} color="green" />
        } else if (status === 'inactive') {
            return <Chip value={'Inactive'} color="inactive" /> 
        } else if (status === 'rejected') {
            return <Chip value={'rejected'} color="red" />
        } else if (status === 'approved') {
            return <Chip value={'approved'} color="blue" />
        } else if (status === 'pending') {
            return <Chip value={'pending'} color="inactive" />
        }
        else {
            return <Chip value={status} color="blue" />
        }
    }

    if (!data || data.length === 0) {
        return (
            <div className="flex justify-center items-center w-full h-96">
                <h1 className="text-base text-gray-400">No Blogs Found</h1>
            </div>
        );
    }
    return (
        <div className="overflow-x-auto mt-6">
            <table className="w-full border-collapse overflow-visible" role="table">
                <thead className="bg-navBtn">
                    <tr className="rounded-md">
                        <th className="p-3 text-left">Srl. No.</th>
                        <th className="p-3 text-left">Category</th>
                        <th className="p-3 text-left">Title</th>
                        <th className="p-3 text-left">Submitted By</th>
                        <th className="p-3 text-center">Submitted On</th>
                        <th className="p-3 text-center">Status</th>
                        <th className="p-3 text-center">Actions</th>
                    </tr>
                </thead>
                {/* Rejection Model */}
                <Modal isOpen={isRejectionModelOpen} setIsOpen={setIsRejectionModelOpen} onClose={() => setIsRejectionModelOpen(false)}>
                    <div>
                        <h1 className="text-base font-semibold">Are you sure you want to reject this blog?</h1>
                        <p className="text-sm text-gray-500 mt-2">Please provide a reason for rejection.</p>
                        <textarea
                            className="w-full border border-gray-300 rounded-md p-2 mt-2"
                            rows="4"
                            placeholder="Enter reason for rejection"
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                        ></textarea>
                        <div className="flex justify-end mt-4 gap-3">
                            <ActionButton
                                variant={'cancel'}
                                text={"Cancel"}
                                className="bg-gray-500 text-white px-4 py-2 rounded-md"
                                handleSubmit={() => setIsRejectionModelOpen(false)}
                            />
                            <ActionButton
                                variant={'submit'}
                                text={"Reject"}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md mr-2"
                                handleSubmit={() => {
                                    handleReject(currentId);
                                    setIsRejectionModelOpen(false);
                                }}
                            />
                        </div>
                    </div>
                </Modal>
                {/* Approve Model */}
                <Modal isOpen={isModelOpen} setIsOpen={setIsModelOpen} onClose={() => setIsModelOpen(false)}>
                    <div>
                        <h1 className="text-base font-semibold">Are you sure you want to approve this blog?</h1>
                        <h1 className="text-base font-semibold">Note: If you are approving an auto approved blog, it will allocate points to the user for successful blog publishing.</h1>
                        <div className="flex justify-end mt-4 gap-3">
                            <ActionButton
                                variant={'cancel'}
                                text={"Cancel"}
                                className="bg-gray-500 text-white px-4 py-2 rounded-md"
                                handleSubmit={() => setIsModelOpen(false)}
                            />
                            <ActionButton
                                variant={'submit'}
                                text={"Approve"}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md mr-2"
                                handleSubmit={() => {
                                    handleApprove(currentId);
                                    setIsModelOpen(false);
                                    toast.success("Blog Approved");
                                }}
                            />
                        </div>
                    </div>
                </Modal>
                {/* Blog Delete Model */}
                <Modal isOpen={deleteModel} setIsOpen={setDeleteModel} onClose={() => setDeleteModel(false)}>
                    <h1 className="text-base font-semibold">Are you sure you want to delete this blog?</h1>
                    <div className="flex justify-end mt-10 gap-3">
                        <ActionButton
                            variant={'cancel'}
                            text={"Cancel"}
                            handleSubmit={() => {
                                setDeleteModel(false);
                            }}
                        />
                        <ActionButton
                            variant={'submit'}
                            text={"Delete"}
                            handleSubmit={() => {
                                handleDelete(currentId);
                                setDeleteModel(false);
                            }}
                        />
                    </div>
                </Modal>
                <tbody>
                    {
                        data.map((item, index) => (
                            <tr
                                key={item._id}
                                className="border-b border-navBtn hover:bg-gray-50 relative"
                            >
                                <td className="p-3 text-left">{index + 1}</td>
                                <td className={`p-3 ${item?.category?.name ? 'text-left' : 'text-center'}`}>{item?.category?.name ?? "-"}</td>
                                <td className="p-3">{item?.title}</td>
                                <td className="p-3">{item?.createdByUser ? item?.createdByUser?.username  : "-"}</td>
                                <td className="p-3 text-center">{item?.createdAt.toRegularDateTime()}</td>
                                <td className="p-3 capitalize flex items-center justify-center">{item?.status ? renderChips(item?.status) : "-"}</td>
                                <td className="p-3 text-center">
                                    {/* View Button */}
                                    <button
                                        className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                                        onClick={() => navigate('/blogs/blog-details', { state: { blogId: item?._id } })}
                                    >
                                        <img src={ViewIcon} alt="view" />
                                    </button>
                                    {
                                        item?.createdByUserType === 'user' && (
                                            item?.approvedOn ? (
                                                item?.status === 'active' ? (
                                                    // Reject Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsRejectionModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoClose className="fill-redDark" />
                                                    </button>
                                                ) : (
                                                    // Approve Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoMdCheckmark className="fill-primaryHoverDark" />
                                                    </button>
                                                )
                                            ) : (
                                                (item?.isRejected || item?.status === 'auto approved') ? (
                                                    // Approve Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoMdCheckmark className="fill-primaryHoverDark" />
                                                    </button>
                                                ) : (
                                                    // Reject Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsRejectionModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoClose className="fill-redDark" />
                                                    </button>
                                                )
                                            )
                                        )
                                    }
                                    {/* Delete Button */}
                                    <button
                                        className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                                        onClick={() => {
                                            setDeleteModel(true);
                                            setCurrentId(item._id);
                                        }}
                                    >
                                        <FaTrash className="fill-chipRed" />
                                    </button>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    );
}

export default UserBlogListTable;